/* tslint:disable */
/* eslint-disable */
/**
 * Pfa API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StarterExmsDto
 */
export interface StarterExmsDto {
    /**
     * 
     * @type {number}
     * @memberof StarterExmsDto
     */
    examId?: number;
    /**
     * 
     * @type {boolean}
     * @memberof StarterExmsDto
     */
    gweGateExam?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof StarterExmsDto
     */
    cancelRequest?: boolean | null;
}

/**
 * Check if a given object implements the StarterExmsDto interface.
 */
export function instanceOfStarterExmsDto(value: object): value is StarterExmsDto {
    return true;
}

export function StarterExmsDtoFromJSON(json: any): StarterExmsDto {
    return StarterExmsDtoFromJSONTyped(json, false);
}

export function StarterExmsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): StarterExmsDto {
    if (json == null) {
        return json;
    }
    return {
        
        'examId': json['examId'] == null ? undefined : json['examId'],
        'gweGateExam': json['gweGateExam'] == null ? undefined : json['gweGateExam'],
        'cancelRequest': json['cancelRequest'] == null ? undefined : json['cancelRequest'],
    };
}

export function StarterExmsDtoToJSON(json: any): StarterExmsDto {
    return StarterExmsDtoToJSONTyped(json, false);
}

export function StarterExmsDtoToJSONTyped(value?: StarterExmsDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'examId': value['examId'],
        'gweGateExam': value['gweGateExam'],
        'cancelRequest': value['cancelRequest'],
    };
}

